import { Component } from '@angular/core';
import { ViewDealStandardQuoteWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/view-deal-standard-quote/view-deal-standard-quote-wrapper.component';

@Component({
  selector: 'app-view-deal-standard-quote-mobile',
  templateUrl: './view-deal-standard-quote-mobile.component.html',
  styleUrls: ['./view-deal-standard-quote-mobile.component.scss'],
})
export class ViewDealStandardQuoteMobileComponent extends ViewDealStandardQuoteWrapperComponent {

}
